function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.988 14.913a.999.999 0 0 0-1.442-.27l-10.318 7.252a.491.491 0 0 1-.71-.164l-12.16-21c-.29-.49-.747-.508-1.018.019L.79 36.753c-.275.509-.018.948.565.948h65.917c.546 0 .784-.42.453-.91L48.988 14.913z"
});

var SvgDefaultImage = function SvgDefaultImage(props) {
  return React.createElement("svg", _extends({
    width: 68,
    height: 38,
    viewBox: "0 0 68 38"
  }, props), _ref);
};

export default SvgDefaultImage;


//////////////////
// WEBPACK FOOTER
// ./src/images/default-image.svg
// module id = 212
// module chunks = 0 1